import styled from "styled-components";
import { borderRadius, borderStyle, borderWidth } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { FieldLabel, FieldRoot } from "../FormField/FormField.styles";
import { KeyAreaInput } from "../../organisms/StoryBuilder/StoryBuilder.styles";

/**
 * `modal` variant wrappers — Figma 5326:88655 (create-data-story details step).
 *
 * Only the *frame* differs from the `builder` variant: the chip row, the chips
 * and the dashed add-chip are shared verbatim from
 * `organisms/StoryBuilder/StoryBuilder.styles`, which already matches this
 * frame's spec exactly.
 */

/** Label + box stack. `FieldRoot`'s `flex: 1 1 0` is for grid placement; in the
 *  modal's column the field must size to its content instead. */
export const ModalField = styled(FieldRoot)`
  flex: 0 0 auto;
`;

/** Same caption-3 / medium-emphasis label as every other form field, but this
 *  box is not a labelable control, so it renders as a plain span (`as="span"`). */
export const ModalFieldLabel = styled(FieldLabel)``;

/** Figma 5326:88645 — white box, structural/200 hairline, radius 8, padding 12. */
export const ChipBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: ${spacing[3]};
  background: ${rawColors.structural.white};
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.structural[200]};
  border-radius: ${borderRadius.lg};
`;

/**
 * The inline "type a name" input that replaces the add-chip. Sized here rather
 * than through an inline `style` prop (which is what this previously used, in
 * px) so the values stay in `rem` and live with the rest of the styling.
 */
export const InlineAudienceInput = styled(KeyAreaInput)`
  width: 11.25rem;
  height: 1.875rem;
`;
